import "styled-components";
import styled from "styled-components";

import { Col } from "./Grid";

interface Props {
  children: any;
  className?: string;
  onClick?: () => void;
  shadow?: boolean;
}

export const Card = ({
  children,
  className,
  onClick,
  shadow = true,
}: Props) => {
  return (
    <StyledCol className={className} onClick={onClick} shadow={shadow}>
      {children}
    </StyledCol>
  );
};

const StyledCol = styled(Col)<{ shadow?: boolean }>`
  background: var(--background-color);
  border-radius: var(--border-radius-md);
  box-shadow: ${(p) => (p.shadow ? `var(--lg-container-drop-shadow)` : `none`)};
  width: 100%;
  @media (max-width: 767px) {
    padding: var(--spacing-md);
  }
`;
